import { NumberInput } from '@maxroll-media-group/common-libs'

export default NumberInput
